import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Button, Modal, Spin, notification } from 'antd';
import { RegisterActions } from '../../components';
import { RegisterRepresentPerson } from '../../forms';
import PropTypes from 'prop-types';
import { getPhysicalPersonId } from '../../reducers/userReducer';
import PropTypesImmutable from 'react-immutable-proptypes';
import {
  fetchMandatePerson,
  deleteMandatePerson,
  updateLegalEntityActionCreator,
} from '../../actions/actionCreators/registerActionCreators';
import {
  showRegisterRepresentPersonModal,
  hideRegisterRepresentPersonModal,
  getRegisterRepresentPersonModal,
} from '../../actions/actionCreators/modalsActionCreators';
import { getDeleteMandatePerson } from '../../reducers/registerAddMandateReducer';
import {
  getMandatePersonList,
  getMandatePersonListPure,
} from '../../reducers/registerReducer';
import { RegisterManagementCompany } from '../';
import MandatePersonsTable from '../../components/MandatePersonsTable/MandatePersonsTable';
import { formRegisterGeneralFields } from '../../constants/formRegister';
import legalEntityStatus from '../../constants/classificators/legalEntityStatus';
import { getLoadingSelector } from '../../utils/asyncHelpers';
import { goToLogin, goToSearch } from '../../utils/gotoLink';
import './RegisterManagement.css';

export class RegisterManagement extends Component {
  static propTypes = {
    fetchMandatePerson: PropTypes.func,
    isLoading: PropTypes.bool,
    mandatePersons: PropTypesImmutable.list,
    updateLegalEntity: PropTypes.func.isRequired,
    isEditMode: PropTypes.bool,
    isAdmin: PropTypes.bool,
    physicalPersonId: PropTypes.number,
    showRequestChangeModal: PropTypes.func,
    showRepresentPersonModal: PropTypes.func.isRequired,
    hideRepresentPersonModal: PropTypes.func.isRequired,
    onSubmitSuccess: PropTypes.func,
  };

  state = {
    editPersonData: null,
  };

  editRepresentPerson = (data) => {
    this.setState({ editPersonData: data });
    this.props.showRepresentPersonModal();
  };

  handleHidePersonModal = () => {
    this.setState({ editPersonData: null });
    this.props.hideRepresentPersonModal();
  };

  componentDidMount() {
    this.props.fetchMandatePerson(
      this.props.legalEntity.get(formRegisterGeneralFields.ID)
    );
  }

  onMasterSubmit = async () => {
    const { updateLegalEntity, legalEntity, t, isAdmin } = this.props;

    await updateLegalEntity(
      legalEntity
        .set(
          formRegisterGeneralFields.STATUS,
          isAdmin ? legalEntityStatus.ACTIVE : legalEntityStatus.NEW
        )
        .toJS()
    );

    if (!isAdmin) {
      goToLogin();
      notification.info({
        description: t('register.message'),
      });
    } else {
      goToSearch();
    }
  };

  render() {
    const {
      hasPrevious,
      hasDone,
      goPrevious,
      t,
      isLoading,
      mandatePersons,
      modalPersonVisible,
      showRepresentPersonModal,
      deleteRepresentPerson,
      isEditMode,
      isAdmin,
      legalEntity,
      physicalPersonId,
      showRequestChangeModal,
      onSubmitSuccess,
    } = this.props;

    // For admin in registration mode, show "Next" to go to Documents tab
    // For non-admin, show "Confirm" to complete registration
    const goNextHandler =
      !isEditMode && isAdmin
        ? onSubmitSuccess
        : () => {
            Modal.confirm({
              content: t('complete.content'),
              okText: t('complete.okText'),
              cancelText: t('complete.cancelText'),
              onOk: this.onMasterSubmit,
            });
          };

    const showDoneButton = !isEditMode && !isAdmin ? hasDone : false;

    return (
      <Spin spinning={isLoading}>
        <div className="register-management-container">
          <h2 className="register-management-container__subtitle">
            {t('representation.subtitlePersons')}
          </h2>
          <MandatePersonsTable
            editRepresent={this.editRepresentPerson}
            deleteRepresent={deleteRepresentPerson}
            t={t}
            data={mandatePersons.toJS()}
            physicalPersonId={physicalPersonId}
          />
          <div className="register-management-container__add-button">
            <Button
              onClick={showRepresentPersonModal}
              size="large"
              type="primary"
            >
              {t('representation.buttonAddPersons')}
            </Button>
          </div>
          {isEditMode && (
            <RegisterManagementCompany t={t} legalEntity={legalEntity} />
          )}
          <RegisterActions
            showRequestChangeModal={showRequestChangeModal}
            hasPrevious={hasPrevious}
            hasDone={showDoneButton}
            goPrevious={goPrevious}
            isEditMode={isEditMode}
            isAdmin={isAdmin}
            showSaveButton={!isEditMode}
            goNext={goNextHandler}
            t={t}
          />
          {modalPersonVisible && (
            <Modal
              title={t('representation.titleModalPersons')}
              wrapClassName="register-management-container__modal"
              open={modalPersonVisible}
              footer={null}
              onCancel={this.handleHidePersonModal}
              width={640}
            >
              <RegisterRepresentPerson
                closeModal={this.handleHidePersonModal}
                initialValues={{
                  originatorLegalEntityId: legalEntity.get('id'),
                  ...this.state.editPersonData,
                }}
                t={t}
              />
            </Modal>
          )}
        </div>
      </Spin>
    );
  }
}

const getLoading = getLoadingSelector(
  getDeleteMandatePerson,
  getMandatePersonListPure
);

const mapStateToProps = (state) => ({
  isLoading: getLoading(state),
  mandatePersons: getMandatePersonList(state),
  modalPersonVisible: getRegisterRepresentPersonModal(state),
  physicalPersonId: getPhysicalPersonId(state),
});

const mapDispatchToProps = {
  deleteRepresentPerson: deleteMandatePerson,
  hideRepresentPersonModal: hideRegisterRepresentPersonModal,
  showRepresentPersonModal: showRegisterRepresentPersonModal,
  updateLegalEntity: updateLegalEntityActionCreator,
  fetchMandatePerson,
};

export default connect(mapStateToProps, mapDispatchToProps)(RegisterManagement);
